/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { PropertyFetchActionTypes } from 'app/paypal/components/PayPalView/state/actions';

/**
 * @typedef {Object} SystemProperty
 * @property {String} key - the property's key
 * @property {String} value - the property's value
 */

/**
 * @typedef {Object} ConnectLocalState
 * @property {SystemProperty|null} data=null - The Property fetched from the config server
 * @property {string|null} fetchError=null - the error message if a fetch error occurred
 * @property {boolean} isFetching=false - whether data is being fetched
 * @property {boolean} isFetchError=false - whether a fetch error has occurred
 * @property {boolean} isFetchQueued=false - whether the fetch lifecycle is queued to execute
 * @property {number|null} lastUpdated=null - the last time the fetched data was updated
 */

/**
 * @type {ConnectLocalState}
 */
const defaultState = {
  data: null,
  fetchError: null,
  isFetching: false,
  isFetchError: false,
  isFetchQueued: false,
  lastUpdated: null
};

/**
 * Reducer used for managing local Stripe Connect state. For Stripe Connect,
 * this means handling the management of the account ID `SystemProperty`.
 *
 * @param {ConnectLocalState} [state=defaultState] - the current state
 * @param {{ type: string, [payload]: * }} action - the action to reduce
 *
 * @return {ConnectLocalState} the next state
 */
function defaultReducer(state = defaultState, action) {
  switch (action.type) {
    case PropertyFetchActionTypes.QUEUE_FETCH: {
      return {
        ...state,
        isFetchQueued: true
      };
    }
    case PropertyFetchActionTypes.START_FETCH: {
      return {
        ...state,
        isFetching: true,
        isFetchQueued: false
      };
    }
    case PropertyFetchActionTypes.SUCCESS_FETCH: {
      return {
        ...state,
        data: action.payload.data,
        fetchError: null,
        isFetching: false,
        isFetchError: false,
        lastUpdated: action.payload.receivedAt
      };
    }
    case PropertyFetchActionTypes.FAILURE_FETCH: {
      return {
        ...state,
        fetchError: action.payload,
        isFetching: false,
        isFetchError: true
      };
    }
    default:
      return state;
  }
}

export default defaultReducer;
export { defaultState };
